/**
 * @fileoverview
 * Application Configuration
 * Registers all providers, interceptors, and global services
 * 
 * @version 2.0.0
 * @author KATALYST TEAM
 */

import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';

// Core imports
import { GlobalErrorHandler } from './@core/error-handler';
import { 
  authInterceptor,
  csrfInterceptor,
  errorInterceptor, 
  loadingInterceptor 
} from './@core/authentication/interceptors';
import { responseInterceptor } from './@core/http/interceptors';

export const appConfig: ApplicationConfig = {
  providers: [
    // Zone change detection
    provideZoneChangeDetection({ eventCoalescing: true }),
    
    // Routing
    provideRouter(routes),
    
    // HTTP Client with interceptors
    provideHttpClient(
      withInterceptors([
        csrfInterceptor,      // Capture CSRF tokens from responses (must be first)
        authInterceptor,      // Add JWT token and CSRF token to requests
        responseInterceptor,  // Unwrap standardized API response format
        errorInterceptor,     // Handle HTTP errors globally (must be after response)
        loadingInterceptor,   // Manage loading state
      ])
    ),
    
    // Global Error Handler
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
  ]
};
